import "./App.css";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

import React, { Component } from "react";
import { Route, BrowserRouter, withRouter } from "react-router-dom";

// Pages
import Login from "./views/login";
import Home from "./views/Home";
import SHECObervation from "./views/SHECObservation";
import FuelTracker from "./views/FuelTracker";
import VehiclePreStart from "./views/VehiclePreStart";
import VFL from "./views/VFL";
import CommunityEngagementCard from "./views/CommunityEngagementCard";

//Manger's Pages
import ManagerFuelTracker from "./views/manager/FuelTracker";

// Page Components
import NavBar from "./views/components/navBar";
import SideNavBar from "./views/components/sidenav/sidenav";

class App extends Component {
  componentDidMount() {
    window.layoutHelpers.setPosition(false, true)
  }

  render() {
    const SideBar = withRouter(SideNavBar)
    const NaviBar = withRouter(NavBar)

    return (
      <BrowserRouter>
        <div className="layout-wrapper layout-2">
          <div className="layout-inner">
            <SideBar />
            <div className="layout-container">
              <NaviBar />
              <Route exact path="/" component={Login}/>
              <Route exact path="/home" component={Home} />
              <Route exact path="/shec_observation" component={SHECObervation} />
              <Route exact path="/fuel_tracker" component={FuelTracker} />
              <Route exact path="/vehicle_pre_start" component={VehiclePreStart} />
              <Route exact path="/vfl" component={VFL} />
              <Route exact path="/community_engagement_card" component={CommunityEngagementCard} />

              <Route exact path="/manager/fuel_tracker" component={ManagerFuelTracker} />
            </div>
            <div className="layout-overlay layout-sidenav-toggle" />
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js